import React, { useState, useEffect } from "react";
import { Grid, TextField, Box, Typography, Select, MenuItem, Tooltip } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";
import { ticketService } from "../../model/_service";


const DropDown = withStyles((theme) => ({
  root: {
    padding: "0.46rem  !important",
    fontSize: "0.75rem !important",
  },
}))(Select);

const useStyles = makeStyles((theme) => ({
  paddingRight: {
    "& input::placeholder": {
      fontSize: "0.75rem !important",
    },
    "& .MuiOutlinedInput-input": {
      padding: "0.62rem  !important",
    },
    "& .MuiInputBase-input": {
      fontSize: "0.75rem !important",
    },
      "& .MuiInputBase-input:focus": {
        fontSize: "1rem !important",
      },
  },
  errorMsgRightAlign: {
    "& .MuiFormHelperText-contained": {
      marginLeft: 0,
      marginRight: 0,
    },
  },
  asterisk: {
    color: theme.palette.eDanger?.dark
  },
  defaultColor: {
    color: theme?.palette?.eMedium?.base + "!important",
    fontSize: "0.75rem !important",
    width: "-webkit-fill-available"
  },
  countryColor: {
    color: theme.palette.eRich?.base + "!important",
    fontSize: "0.75rem !important",
    width: "-webkit-fill-available"
  },
  menuItems: {
    justifyContent: "flex-start !important",
    color: theme.palette.eRich?.base + " !important",
  },
  defaultColorDivison: {
    color: theme?.palette?.eMedium?.base + "!important",
  },marginBT:{
    marginBottom:"1rem"
  },
  textColor:{
    color: theme?.palette?.eDark?.base + "!important",
  }
}));

const CustomTextField = withStyles((theme) => ({
  root: {
    "& .MuiFormHelperText-root.Mui-error": {
      color: theme.palette.eDanger?.dark,
    },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.eDanger?.dark
    },
    "& ::placeholder": {
      color: theme.palette.eDark?.base
    },
    "& .MuiInputBase-input": {
      fontSize: "0.75rem !important",
      color: theme.palette.eDark?.base + " !important"
    },
  },
}))(TextField);

export default function InputForm(props) {
  const { divisionList, 
    address1, address2, postOffice, division, postcode, district, thana,
    setDistrict, setAddress1, setAddress2, setPostOffice, setDivision, setDivisionCode, setPostCode, setThana,
    sameAsPremiseCheck,sndValue,sndCode,setSndValue,setSndCode,SndInConnection,districtdropdown, setdistrictdropdown,thanadropdown, setthanadropdown,
    existingCustomer,   masterDataAddress1Mailing,masterDataAddress2Mailing,masterDataPostOfficeMailing,masterDataPostCodeMailing,masterDataDistrictMailing,
    masterDataDivisionCodeMailing,
    masterDataDivisionMailing,
    masterDataThanaMailing,
 
  } = props;
  const classes = useStyles();
  const [isRequiredError, setIsRequiredError] = useState({});
  const [invalidZipError, setInvalidZipError] = useState(false);
  const labels = useSelector((store) => store?.labels?.data?.getLabels?.E_PREMISE_DETAILS);
  const zipLength = useSelector((store) => store?.parametersWidgets?.ParameterLookup?.ZIPCODE_MIN_LENGTH);
  const zipLengthError = useSelector((store) => store?.parametersWidgets?.ParameterLookup?.ZIPCODE_MIN_LENGTH);
  const languageCode = useSelector((store) => store?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE);
  const { t: premiseLabel, ready: premiseLabelReady } = useTranslation("label-E_PREMISE_DETAILS");
  const handleBlur = (event) => {
    const { name, value } = event.target;
    if (value) {
      setIsRequiredError({ ...isRequiredError, [name]: false });
      if (name === "postcode" && parseInt(value) >= parseInt(7001)) {
        setInvalidZipError(true);
      }else if (name === "postcode" && parseInt(value) <= parseInt(999)) {
        setInvalidZipError(true);
      } else if (name === "postcode") {
        setInvalidZipError(false);
      }
    } else {
      setIsRequiredError({ ...isRequiredError, [name]: true });
    }
  };
  useEffect(() => {
    if (sameAsPremiseCheck) {
      setIsRequiredError({});
      setInvalidZipError(false);
    }
  }, [sameAsPremiseCheck]);

  const dropDownMenuProps = {
    disableScrollLock: false,
    anchorOrigin: {
      vertical: "bottom"
    },
    transformOrigin: {
      vertical: "top"
    },
    getContentAnchorEl: null
  }
  const [thanaList, setthanaList] = useState([])
  const[districtList,setdistrictList]=useState([])
  const postalMaxNumber = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_NESCO_POSTAL_MAX);
  const postalMinNumber = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_NESCO_POSTAL_MIN);
  const handleDivision=(e,key) =>{
    setDivision(e.target.value);
    setDivisionCode(divisionList?.find(item => item?.dropDownValue === e.target.value)?.dropDownCode);
    setdistrictdropdown(key.key.slice(2))
    setDistrict("");
    setSndValue("");
    setSndCode("")
  }
  const handleDistrict = (e,key) => {
    setDistrict(e.target.value)
    setthanadropdown(districtList?.find(item => item?.dropDownValue === e.target.value)?.dropDownCode)
    setThana("");
  }
  useEffect(() => {
    if (languageCode&&districtdropdown) {
      ticketService.getDropdownpData(districtdropdown, languageCode)
        .then((res) => {
          let response = res.data.data.getDropdownData.sort((a, b) => a.dropDownValue < b.dropDownValue ? -1 : 1)
          setdistrictList(response);
        })
        .catch(() => {
          setdistrictList(null);
        });
    }
  }, [languageCode,districtdropdown]);
  useEffect(() => {
    if (languageCode&&thanadropdown) {
      ticketService.getDropdownpData(thanadropdown, languageCode)
        .then((res) => {
          let response = res?.data?.data?.getDropdownData?.sort((a, b) => a.dropDownValue < b.dropDownValue ? -1 : 1)
          setthanaList(response);
        })
        .catch(() => {
          setthanaList(null);
        });
    }
  }, [languageCode,thanadropdown]);
  
  const[sndValueList,setSndValueList]=useState([])
  useEffect(() => {
    if (languageCode&&districtdropdown) {
      ticketService.getDropdownpData('SND'+districtdropdown, languageCode)
        .then((res) => {
          let response = res.data.data.getDropdownData.sort((a, b) => a.dropDownValue < b.dropDownValue ? -1 : 1)
          setSndValueList(response);
        })
        .catch(() => {
          setSndValueList(null);
        });
    }
  }, [languageCode,districtdropdown]);

  const handleSndValue = (e) =>{
    setSndValue(e.target.value)
    setSndCode(sndValueList?.find(item => item?.dropDownValue === e.target.value)?.dropDownCode)
  }

  return (
    <Grid container spacing={0} direction="row">
      <Grid item xs={12} sm={6}>
        <Box px={1}>
          <Grid container spacing={1} direction="row">
            <Grid item xs={12}>
              <Typography variant="caption">
                <Box pb={0.2}>
                  {premiseLabelReady ?  premiseLabel("E_PREMISE_ADDRESS_LINE_1") : <Skeleton />}<span className={classes.asterisk}>*</span>
                </Box>
              </Typography>
              <CustomTextField
                variant="outlined"
                name="address1"
                fullWidth
                value={address1 ? address1 : existingCustomer=="yes"?masterDataAddress1Mailing:""}
                onChange={e => setAddress1(e.target.value)}
                onBlur={handleBlur}
                error={isRequiredError?.address1}
                helperText={
                  isRequiredError?.address1 ? (
                    premiseLabelReady ? premiseLabel("E_PREMISE_ADDRESS_LINE_1") +
                    labels?.E_PREMISE_DETAILS_IS_REQUIRED : ''
                  ) : (
                    <div>&nbsp;</div>
                  )
                }
                autoComplete="off"
                placeholder={
                  premiseLabelReady ? premiseLabel("E_PREMISE_ADDRESS_LINE_1_PLACEHOLDER") : ""
                }
                className={[classes.errorMsgRightAlign, classes.paddingRight]}
                disabled={sameAsPremiseCheck || existingCustomer=="yes"}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="caption">
              {
                premiseLabelReady ?
                <Box pb={0.2}>{premiseLabel("E_PREMISE_ADDRESS_LINE_2")}</Box>
                : <Skeleton />
              }
              </Typography>
              <CustomTextField
                variant="outlined"
                name="address2"
                fullWidth
                value={address2 ? address2 : existingCustomer=="yes"?masterDataAddress2Mailing:""}
                onChange={e => setAddress2(e.target.value)}
                helperText={
                  <div>&nbsp;</div>
                }
                autoComplete="off"
                placeholder={premiseLabelReady ? premiseLabel("E_PREMISE_ADDRESS_LINE_2_PLACEHOLDER") : <Skeleton />}
                className={[classes.errorMsgRightAlign, classes.paddingRight]}
                disabled={sameAsPremiseCheck || existingCustomer=="yes"}
              />
              {/* c2m is accepting district as division so in frontend it is district but in backend it is division */}
              <Grid item xs={12}> 
              <Typography variant="caption">
                <Box pb={0.2}>{premiseLabelReady ? premiseLabel("E_NCR_PREMISE_DIVISION") : ''}<span className={classes.asterisk}>*</span></Box> 
              </Typography>
              <DropDown
                    fullWidth
                    variant="outlined"
                    labelId="label"
                    id="division"
                    value={division ? division : existingCustomer=="yes"?masterDataDivisionMailing:""}
                    onChange={handleDivision}
                    className={existingCustomer=="yes"?classes.textColor:!division && classes.defaultColorDivison}
                    renderValue={(selected) => {
                      if (selected?.length == 0) {
                        return (premiseLabelReady ? premiseLabel("E_PREMISE_SELECT")+" "+premiseLabel("E_NCR_PREMISE_DIVISION") : '')
                      }
                      return selected;
                    }}
                    displayEmpty
                    MenuProps={dropDownMenuProps}
                    disabled={sameAsPremiseCheck || existingCustomer=="yes"}
                  >
                    {divisionList?.map((item, k) => {
                      return (
                        <MenuItem value={item.dropDownValue} key={item.dropDownCode}>
                          {item.dropDownValue}
                        </MenuItem>
                      );
                    })}
                  </DropDown>
                  <div>&nbsp;</div>
            </Grid>
               <Grid item xs={12}> 
              <Typography variant="caption">
                <Box pb={0.2}>{premiseLabelReady ? premiseLabel("E_PREMISE_DISTRICT") : ''}<span className={classes.asterisk}>*</span></Box> 
              </Typography>
              {!division?.length ? (
                        <Tooltip
                          title={premiseLabelReady ? premiseLabel("E_SERVICE_TOOLTIP2") : ''}
                        > 
              <DropDown
              fullWidth
              variant="outlined"
              labelId="label"
              id="district"
              value={district ? district : existingCustomer=="yes" ? masterDataDistrictMailing:""}
              onChange={handleDistrict}
              className={ existingCustomer=="yes"?classes.textColor:!district && classes.defaultColorDivison}
             
              // disabled
              renderValue={(selected) => {
                if (selected?.length == 0) {
                  return (premiseLabelReady ? premiseLabel("E_PREMISE_SELECT")+" "+premiseLabel("E_PREMISE_THANA_UPAZILA") : '')
                }
                return selected;
              }}
              displayEmpty
              MenuProps={dropDownMenuProps}
              disabled={true || existingCustomer=="yes"}
              // disabled={sameAsPremiseCheck}
            >
              {districtList?.map((item, k) => {
                return (
                  <MenuItem value={item.dropDownValue} key={item.dropDownCode}>
                    {item.dropDownValue}
                  </MenuItem>
                );
              })}
            </DropDown>
              </Tooltip>) : (
              <DropDown
                    fullWidth
                    variant="outlined"
                    labelId="label"
                    id="district"
                    value={district ? district : existingCustomer=="yes" ? masterDataDistrictMailing:""}
                    onChange={handleDistrict}
                    className={ existingCustomer=="yes"?classes.textColor:!district && classes.defaultColorDivison}
                    renderValue={(selected) => {
                      if (selected?.length == 0) {
                        return (premiseLabelReady ? premiseLabel("E_PREMISE_SELECT")+" "+premiseLabel("E_PREMISE_DISTRICT") : '')
                      }
                      return selected;
                    }}
                    displayEmpty
                    MenuProps={dropDownMenuProps}
                    disabled={sameAsPremiseCheck || existingCustomer=="yes"}
                  >
                    {districtList?.map((item, k) => {
                      return (
                        <MenuItem value={item.dropDownValue} key={item.dropDownCode}>
                          {item.dropDownValue}
                        </MenuItem>
                      );
                    })}
                  </DropDown>)}
                  <div>&nbsp;</div>
            </Grid>
            </Grid>
          
          </Grid>
        </Box>
      </Grid>
      <Grid item xs={12} sm={6 }>
        <Box px={1}>
          <Grid container spacing={1} direction="row" >
          <Grid item xs={12} className={classes.marginBT}>
              <Typography variant="caption">
                <Box pb={0.2}>{premiseLabelReady ? premiseLabel("E_PREMISE_THANA_UPAZILA"): <Skeleton />}</Box>
              </Typography>
              {!district?.length ? (
                        <Tooltip
                          title={premiseLabelReady ? premiseLabel("E_SERVICE_TOOLTIP") : ''}
                        > 
              <DropDown
              fullWidth
              variant="outlined"
              labelId="label"
              id="thana"
              value={thana ? thana : existingCustomer=="yes"?masterDataThanaMailing:""}
              onChange={e => setThana(e.target.value)}
              className={ existingCustomer=="yes"?classes.textColor:!thana && classes.defaultColorDivison}
              
              renderValue={(selected) => {
                if (selected?.length == 0) {
                  return (premiseLabelReady ? premiseLabel("E_PREMISE_SELECT")+" "+premiseLabel("E_PREMISE_THANA_UPAZILA") : '')
                }
                return selected;
              }}
              displayEmpty
              MenuProps={dropDownMenuProps}
              disabled={true || existingCustomer=="yes"}
              // disabled={sameAsPremiseCheck}
            >
              {thanaList?.map((item, k) => {
                return (
                  <MenuItem value={item.dropDownValue} key={item.dropDownCode}>
                    {item.dropDownValue}
                  </MenuItem>
                );
              })}
            </DropDown>
              </Tooltip>):    (  <DropDown
              fullWidth
              variant="outlined"
              labelId="label"
              id="thana"
              value={thana ? thana : ""}
              onChange={e => setThana(e.target.value)}
              className={ existingCustomer=="yes"?classes.textColor:!thana && classes.defaultColorDivison}
              // disabled
              renderValue={(selected) => {
                if (selected?.length == 0) {
                  return (premiseLabelReady ? premiseLabel("E_PREMISE_SELECT")+" "+premiseLabel("E_PREMISE_THANA_UPAZILA") : '')
                }
                return selected;
              }}
              displayEmpty
              MenuProps={dropDownMenuProps}
              disabled={sameAsPremiseCheck || existingCustomer=="yes"}
            >
              {thanaList?.map((item, k) => {
                return (
                  <MenuItem value={item.dropDownValue} key={item.dropDownCode}>
                    {item.dropDownValue}
                  </MenuItem>
                );
              })}
            </DropDown>)}
            </Grid>
            {SndInConnection ? (<>
        <Grid item xs={12}  className={classes.marginBT}>
              <Typography variant="caption">
                <Box pb={0.2}>{premiseLabelReady ? premiseLabel("E_SND_DROPDOWN"): <Skeleton />}<span className={classes.asterisk}>*</span></Box>
              </Typography>
              {!division?.length ? (
                        <Tooltip
                          title={premiseLabelReady ? premiseLabel("E_SERVICE_TOOLTIP2") : ''}
                        > 
              <DropDown
              fullWidth
              variant="outlined"
              labelId="label"
              id="snd"
              value={sndValue ? sndValue : ''}
              onChange={handleSndValue}
              className={ existingCustomer=="yes"?classes.textColor:!thana && classes.defaultColorDivison}
              disabled={true || existingCustomer=="yes"}
              renderValue={(selected) => {
                if (selected?.length == 0) {
                  return (premiseLabelReady ? premiseLabel("E_PREMISE_SELECT")+" "+premiseLabel("E_SND_DROPDOWN_VALUE") : '')
                }
                return selected;
              }}
              displayEmpty
              MenuProps={dropDownMenuProps}
            >
              {sndValueList?.map((item, k) => {
                return (
                  <MenuItem value={item.dropDownValue} key={item.dropDownCode}>
                    {item.dropDownValue}
                  </MenuItem>
                );
              })}
            </DropDown>
              </Tooltip>):    (  <DropDown
              fullWidth
              variant="outlined"
              labelId="label"
              id="snd"
              value={sndValue ? sndValue : ''}
              onChange={handleSndValue}
              className={ existingCustomer=="yes"?classes.textColor:!thana && classes.defaultColorDivison}
              renderValue={(selected) => {
                if (selected?.length == 0) {
                  return (premiseLabelReady ? premiseLabel("E_PREMISE_SELECT")+" "+premiseLabel("E_SND_DROPDOWN_VALUE") : '')
                }
                return selected;
              }}
              displayEmpty
              MenuProps={dropDownMenuProps}
              disabled={sameAsPremiseCheck || existingCustomer=="yes"}
            >
              {sndValueList?.map((item, k) => {
                return (
                  <MenuItem value={item.dropDownValue} key={item.dropDownCode}>
                    {item.dropDownValue}
                  </MenuItem>
                );
              })}
            </DropDown>)}
            </Grid></>) : null}
            <Grid item xs={12}>
            {
              premiseLabelReady ?
              <Typography variant="caption">
                <Box pb={0.2}>{premiseLabel("E_PREMISE_POST_OFFICE")}</Box>
              </Typography>
              : <Skeleton />
            }
              <CustomTextField
                variant="outlined"
                name="postOffice"
                fullWidth
                value={postOffice ? postOffice : existingCustomer=="yes"?masterDataPostOfficeMailing:""}
                onChange={e => setPostOffice(e.target.value)}
                helperText={
                  <div>&nbsp;</div>
                }
                autoComplete="off"
                placeholder={premiseLabelReady ? premiseLabel("E_PREMISE_POST_OFFICE_PLACEHOLDER") : ''}
                className={[classes.errorMsgRightAlign, classes.paddingRight]}
                disabled={sameAsPremiseCheck || existingCustomer=="yes"}
              />
            </Grid>     
            <Grid item xs={12}>
            {
              premiseLabelReady?
              <Typography variant="caption">
                <Box pb={0.2}>{premiseLabel("E_PREMISE_POST_CODE")}<span className={classes.asterisk}>*</span></Box>
              </Typography>
              : <Skeleton />
            }
              <CustomTextField
                variant="outlined"
                name="postcode"
                type="number"
                fullWidth
                onInput={(e) => {
                  e.target.value = Math.max(0, parseInt(e.target.value))
                    .toString()
                    .slice(0, parseInt(zipLength));
                }}
                value={postcode ? postcode : existingCustomer=="yes"?masterDataPostCodeMailing:""}
                onChange={e => setPostCode(e.target.value)}
                onBlur={handleBlur}
                error={isRequiredError?.postcode || invalidZipError}
                helperText={
                  isRequiredError?.postcode ? (
                    premiseLabelReady ?premiseLabel("E_PREMISE_POST_CODE") +
                    labels?.E_PREMISE_DETAILS_IS_REQUIRED : ''
                  ) : invalidZipError ? (
                    labels?.E_PREMISE_DETAILS_INVALID_ZIP
                  ) : (
                    <div>&nbsp;</div>
                  )
                }
                autoComplete="off"
                placeholder={premiseLabelReady ? premiseLabel("E_PREMISE_POST_CODE") : ''}
                className={[classes.errorMsgRightAlign, classes.paddingRight]}
                disabled={sameAsPremiseCheck || existingCustomer=="yes"}
              />
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
}
